import axios from 'axios';

import { publicAxiosHeader, getV1RootUrl } from 'common/helpers/apiHelper';

export const listLoyaltyTiers = () =>
  axios.get(`${getV1RootUrl()}/loyalty-tier/for-web`, publicAxiosHeader());
